import React from "react";

function MilesRankDetailModalStatsSection() {
  const stats = [
    {
      label: "Points This Week",
      amount: "1,294",
    },
    {
      label: "Points This Month",
      amount: "1,294",
    },
    {
      label: "Total Points Earned",
      amount: "1,294",
    },
    {
      label: "Highest Points in a Cycle",
      amount: "1,294",
    },
  ];

  return (
    <div className="flex gap-4 flex-wrap w-full justify-between border-b pb-6 border-black/10 ">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex w-[48%] h-28 rounded-xl flex-col border border-black/10 p-4 justify-center bg-[#F9F9F9]"
        >
          <span className="text-sm">{stat.label}</span>
          <span className="text-lg">{stat.amount}</span>
        </div>
      ))}
    </div>
  );
}

export default MilesRankDetailModalStatsSection;
